<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card style="border-radius: 10px;">
        <div slot="header">
          <h3 class="card-title mb-0">Dispositivo y licencia</h3>
        </div>
        <vs-row class="mt-4">
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <CompanySelector v-model="companyId"/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <vs-input
                class="inputx w-100"
                readonly
                label="Tipo de dispositivo"
                placeholder="Tipo"
                v-model="deviceType"/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <vs-input
                class="inputx w-100"
                readonly
                label="Nombre del dispositivo"
                placeholder="Dispositivo"
                v-model="name"/>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <vs-input
                class="inputx w-100"
                readonly
                label="Estado"
                placeholder="Estado"
                v-model="status"/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <vs-input
                class="inputx w-100"
                readonly
                label="Volumen disco"
                placeholder="Volumen disco"
                v-model="volume"/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="8" vs-sm="8">
            <vs-input
                class="inputx w-100"
                readonly
                label="Mac address"
                placeholder="Mac"
                v-model="macAddress"/>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <textarea
              class="mytextarea"
              readonly
              rows="5"
              id="license"
              v-model="license"
              placeholder="Generar licencia"
              style="font-size: 16px !important; margin: 10px;"></textarea>

        </vs-row>

        <vs-row style="margin-bottom: 1rem;">

          <vs-col vs-lg="6" vs-xs="6" vs-sm="6">
            <div class="d-flex ">
              <vs-button
                  icon="add"
                  color="primary"
                  class="flex-shrink-0 ml-auto"
                  @click="saveDevice">
                Generar licencia
              </vs-button>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>

      <div :key="forceRender">
        <vs-card style="border-radius: 10px;">
          <vs-table
              :max-items="descriptionItems[0]"
              pagination
              search
              v-model="selected"
              :data="devices">
            <template slot="header">
              <h3>
                Dispositivos vinculados
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                Nombre dispositivo
              </vs-th>
              <vs-th>
                Estado
              </vs-th>
              <vs-th>
                Volumen disco
              </vs-th>
              <vs-th>
                Mac address
              </vs-th>
              <vs-th>
                Licencia
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].title">
                  {{ data[indextr].title }}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>

                <vs-td :data="data[indextr].info.vol">
                  {{ parseInfo(data[indextr].info).vol }}
                </vs-td>

                <vs-td :data="data[indextr].info.macAddress">
                  {{ parseInfo(data[indextr].info).macAddress }}
                </vs-td>
                <vs-td>
                  <textarea
                      class="mytextarea"
                      label="Licencia"
                      disabled
                      rows="5"
                      v-model="parseInfo(data[indextr].info).license"></textarea>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </div>

    </vs-col>
  </vs-row>
</template>

<script>

import {DETAILS_STATUS} from "@/global/constants";
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import toast from "@/global/ToastConfig";

export default {
  components: {CompanySelector},
  data: () => ({

    name: null,
    actualDevice: null,
    isLoading: false,
    companyId: null,
    deviceType: "Cajero",
    deviceName: null,
    status: null,
    dinamycValueFields: [],
    statusList: [],
    deviceTypes: [],
    selected: [],
    descriptionItems: [10, 50, 100],
    license: null,
    devices: [],
    macAddress: null,
    volume: null,
    forceRender: 0,
  }),
  watch: {
    selected() {
      const parseInfo = this.parseInfo(this.selected.info);
      this.status = this.selected.status;
      this.name = this.selected.title;
      this.license = parseInfo.license !== undefined ? parseInfo.license : null;
      this.macAddress = parseInfo.macAddress;
      this.volume = parseInfo.vol;
      console.log("esta es la que se asigno de la licencia  ===> ", this.selected);
    }
  },
  mounted() {
    this.getListDevices();
    this.statusList = this.getStatusList();
  },
  methods: {
    getListDevices() {
      this.isLoading = true;
      deviceEndpoint.getListDevices()
          .then(info => {
            this.isLoading = false;
            this.devices = this.findDeviceTypeATM(info);
          });
    },
    findDeviceTypeATM(devices){
      const atm = 49;
      return devices.filter(device => device.deviceType.code === atm)
          .map(device => {
            const statusObj = this.statusList.find(item => item.code === device.status);
            return {
              ...device,
              status: statusObj ? statusObj.description : "No encontrado",

            };
          });
    },
    confirmlicense() {
      toast.ask(this, "¿Está seguro generar otra licencia?")
          .then(result => {
            if (!result) {
              return;
            }
            this.isLoading = true;
            this.save();
          });
    },
    saveDevice() {
      try {
        this.validateSave();
        if (this.license !== null) {
          this.confirmlicense();
          return;
        }
        this.save();
      } catch (ex) {
        toast.error(ex.message);
      }
    },
    save() {
      const obj = {
        code: this.selected.code,
        info: JSON.stringify({
          vol: this.volume,
          macAddress: this.macAddress,
          license: this.license,
        }),
      };
      deviceEndpoint.generateLicense(obj)
          .then(result => {
            if (result > 0){
              this.searchSelectedDevice();
              this.$forceUpdate();
              this.isLoading = false;
            }
          });

    },
    async searchSelectedDevice(){
      const devicesAll = await deviceEndpoint.getListDevices()
      this.devices = this.findDeviceTypeATM(devicesAll);
      const device = this.devices.find(device => device.code === this.selected.code);
      const parseInfo = this.parseInfo(device.info);
      this.selected.license = parseInfo.license !== undefined ? parseInfo.license : null;
      this.license = parseInfo.license !== undefined ? parseInfo.license : null;
      this.$forceUpdate();
    },
    validateSave() {
      if (!this.selected || this.selected.length <= 0) {
        throw new Error("Por favor seleccione un dispositivo");
      }
    },
    parseInfo(info) {
      try {
        return JSON.parse(info);
      } catch (error) {
        toast.error("Error al analizar la informacion del json")
      }
    },
    getDeviceObject(device, father) {
      const obj = {
        code: device.code,
        company: {
          code: device.company.code ? device.company.code : device.company,
        },
        title: device.deviceName,
        deviceType: {
          code: device.deviceType.code
              ? device.deviceType.code
              : device.deviceType,
        },
        status: device.status,
        info: JSON.stringify(device.dinamycValueFields),

      };
      return obj;
    },
    getStatusList() {
      const list = [];
      for (const key in DETAILS_STATUS) {
        if (Object.hasOwnProperty.call(DETAILS_STATUS, key)) {
          const itemStatus = DETAILS_STATUS[key];
          list.push(itemStatus);
        }
      }
      return list;
    },
  },


};
</script>

<style>
.mytextarea {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  height: 38px;
}
</style>
